import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { CommonErrorCode, ProjectErrorCode } from '~commonInfra/utils/ErrorCodes';
import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { IError } from '~src/httpClient/serverApi/types/IError';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { Projects } from '~src/projects/resources/Projects';

import { IProjectBase } from '../models/IProjectInfo';

export namespace ChangeProjectDescriptionAction {

  export function execute(project: IProjectBase, newDescription: string): Promise<IResult> {

    return Projects.setDescription(project.id, newDescription).then((result: IResult) => {
      if (result.errors && result.errors.length) {
        ToasterService.instance.pop({ type: ToastType.Error, text: errorMessageFor(result.errors[0], project) });
      } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.editDescriptionSuccessful() });
      }
      return result;
    });
  }

  function errorMessageFor(error: IError, project: IProjectBase) {
    switch (error.code) {
      case ProjectErrorCode.ProjectDescriptionGreaterThanMaxLength:
        return Messages.errorProjectDescriptionTooLong();
      case CommonErrorCode.ProjectNotFound:
        return Messages.errorProjectNotFound({ PROJECT_NAME: L10n.elideIfLong(project.name) });
      default:
        return Messages.errorUnknown();
    }
  }
}

export type ChangeProjectDescriptionAction = typeof ChangeProjectDescriptionAction;
